const TOKEN_KEY = 'token';
const USER_KEY = 'user';
export const AUTH_TOKEN_KEY = TOKEN_KEY;
export const LAST_ACTIVITY_KEY = 'lastActivity';

const IDLE_TIMEOUT_MINUTES = parseInt(
  process.env.REACT_APP_SESSION_IDLE_MINUTES || '60',
  10
);
export const IDLE_TIMEOUT_MS = IDLE_TIMEOUT_MINUTES * 60 * 1000;

/** Persist token + user after password or OTP login. */
export function completeLogin(data) {
  if (!data?.token) {
    throw new Error('Missing auth token');
  }
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(
    USER_KEY,
    JSON.stringify({
      email: data.email,
      username: data.username,
    })
  );
  touchLastActivity();
}

export function touchLastActivity() {
  try {
    localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
  } catch {
    // ignore
  }
}

export function getLastActivityMs() {
  try {
    const raw = localStorage.getItem(LAST_ACTIVITY_KEY);
    if (!raw) {
      return null;
    }
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function isIdleExpired() {
  const last = getLastActivityMs();
  if (last == null) {
    return false;
  }
  return Date.now() - last > IDLE_TIMEOUT_MS;
}

export function msUntilIdleExpiry() {
  const last = getLastActivityMs();
  if (last == null) {
    return IDLE_TIMEOUT_MS;
  }
  return Math.max(0, IDLE_TIMEOUT_MS - (Date.now() - last));
}

export function clearAuthStorage() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(LAST_ACTIVITY_KEY);
  } catch {
    // ignore
  }
}

export function getTokenExpiryMs(token) {
  if (!token || typeof token !== 'string') {
    return null;
  }
  try {
    const parts = token.split('.');
    if (parts.length < 2) {
      return null;
    }
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (!payload?.exp) {
      return null;
    }
    return payload.exp * 1000;
  } catch {
    return null;
  }
}

export function isTokenExpired(token) {
  const expMs = getTokenExpiryMs(token);
  if (!expMs) {
    return true;
  }
  return Date.now() >= expMs;
}

export function msUntilTokenExpiry(token) {
  const expMs = getTokenExpiryMs(token);
  if (!expMs) {
    return 0;
  }
  return Math.max(0, expMs - Date.now());
}

/** Milliseconds until the earlier of JWT midnight expiry or idle timeout. */
export function msUntilSessionExpiry(token) {
  return Math.min(msUntilTokenExpiry(token), msUntilIdleExpiry());
}

export function isSessionExpired(token) {
  if (!token || isTokenExpired(token)) {
    return true;
  }
  return isIdleExpired();
}
